import { render, staticRenderFns } from "./PastOrders.vue?vue&type=template&id=a9b1d762&scoped=true&"
import script from "./PastOrders.vue?vue&type=script&lang=js&"
export * from "./PastOrders.vue?vue&type=script&lang=js&"
import style0 from "./PastOrders.vue?vue&type=style&index=0&id=a9b1d762&lang=css&scoped=true&"
import style1 from "./PastOrders.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9b1d762",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VCol,VDataTable,VLayout,VRow,VSpacer})
